import { IFeature, IFeatureSet } from '@esri/arcgis-rest-types';
import { geojsonToArcGIS as g2a, arcgisToGeoJSON as a2g } from '@esri/arcgis-to-geojson-utils';
import * as GeoJSON from 'geojson';

import { IQueryOptions } from '../tasks';
import { Geometry } from '../types';

type ArcGISGeometry = Pick<IQueryOptions, 'geometry' | 'geometryType'>;

export function geojsonToArcGIS(
  geoJSON: GeoJSON.FeatureCollection | GeoJSON.GeometryCollection,
): ArcGISGeometry[];
export function geojsonToArcGIS(geoJSON: GeoJSON.Geometry | GeoJSON.Feature): ArcGISGeometry;
export function geojsonToArcGIS(geoJSON: GeoJSON.GeoJSON): ArcGISGeometry | ArcGISGeometry[] {
  switch (geoJSON.type) {
    case 'Point':
      return {
        geometry: g2a(geoJSON),
        geometryType: 'esriGeometryPoint',
      };
    case 'MultiPoint':
      return {
        geometry: g2a(geoJSON),
        geometryType: 'esriGeometryMultipoint',
      };
    case 'LineString':
    case 'MultiLineString':
      return {
        geometry: g2a(geoJSON),
        geometryType: 'esriGeometryPolyline',
      };
    case 'Polygon':
    case 'MultiPolygon':
      return {
        geometry: g2a(geoJSON),
        geometryType: 'esriGeometryPolygon',
      };
    case 'Feature':
      return geojsonToArcGIS(geoJSON.geometry);
    case 'FeatureCollection':
      return geoJSON.features.map(geojsonToArcGIS);
    case 'GeometryCollection':
      return geoJSON.geometries.map(geojsonToArcGIS);
  }
}

export function arcgisToGeoJSON(
  arcGIS: IFeatureSet,
  idAttribute?: string,
): GeoJSON.FeatureCollection;
export function arcgisToGeoJSON(arcGIS: IFeature, idAttribute?: string): GeoJSON.Feature;
export function arcgisToGeoJSON(
  arcGIS: Geometry,
  idAttribute?: string,
): Exclude<GeoJSON.Geometry, GeoJSON.GeometryCollection>;
export function arcgisToGeoJSON(
  arcGIS: IFeatureSet | IFeature | Geometry,
  idAttribute?: string,
): GeoJSON.GeoJSON {
  return a2g(arcGIS, idAttribute);
}
